var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"absolute":"","opacity":"0.7","value":!_vm.isPay}},[_vm._v(" 啟用功能，用更棒的方式管理日記本！ "),_c('div',{staticClass:"text-center mt-3"},[_c('v-btn',{staticClass:"white--text normal-case",attrs:{"color":"deep-orange lighten-1","depressed":"","href":"https://www.mangax.co/mangachat/pricing/","target":"_blank"}},[_vm._v(" 查看方案價格 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }